import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
})
export class UserAvatarComponent implements OnInit {
  @Input() name: string = '';
  @Input() email: string = '';
  initials: string = '';
  bgColor: string = '';

  constructor() {}

  ngOnInit(): void {
    this.initials = this.getInitials(this.name);
    this.bgColor = this.getConsistentColor(this.name, this.email); // Generate consistent color
  }

  getInitials(name: string): string {
    const names = name.split(' ');
    const initials = names
      .map((n) => n[0].toUpperCase())
      .join('')
      .substring(0, 2);
    return initials;
  }

  // Hash function to generate a number based on name and email
  generateHash(input: string): number {
    let hash = 0;
    for (let i = 0; i < input.length; i++) {
      hash = input.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  // Generate a consistent color based on the hash of name + email
  getConsistentColor(name: string, email: string): string {
    const pastelColors = [
      '#AEC6CF',
      '#FFB3BA',
      '#FFDFBA',
      '#FFFFBA',
      '#BFFCC6',
      '#B39EB5',
      '#CFCFC4',
      '#FDFD96',
      '#77DD77',
      '#C1C1FF',
      '#F4C2C2',
      '#FFDAC1',
      '#FFDEAD',
      '#D4A5A5',
      '#E3E3B3',
      '#FFD1DC',
      '#F2E6D6',
      '#D1C3E0',
      '#FADADD',
      '#D5E8D4',
      '#C5D1EB',
      '#FFE5B4',
      '#F5B7B1',
      '#D6EAF8',
      '#F7C6C7',
      '#E6B0AA',
      '#F5CBA7',
      '#D5DBDB',
      '#A9CCE3',
      '#D7BDE2',
      '#C39BD3',
      '#EDBB99',
      '#ABEBC6',
      '#D1F2EB',
      '#FCF3CF',
      '#F9E79F',
      '#FAD7A0',
      '#A3E4D7',
      '#AED6F1',
      '#D6DBDF',
      '#E8DAEF',
      '#EBDEF0',
      '#F4ECF7',
      '#FEF9E7',
      '#FEF5E7',
      '#FDEDEC',
      '#FDF2E9',
      '#FAE5D3',
      '#F9EBEA',
      '#F6DDCC',
    ];

    // Combine name and email to generate a unique hash
    const combined = name + email;
    const hash = this.generateHash(combined);

    // Use the hash to pick a color from the list
    const index = Math.abs(hash) % pastelColors.length;
    return pastelColors[index];
  }
}
